import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import useFormat from "../../hooks/useFormat";
import { toast } from "react-toastify";
import { useEffect, useState, useCallback } from "react";
import { calculateTotals, calculatePromoCodes } from "../../redux/actions";

const PaymentSummary = ({ selectedLines }) => {
  const { formatPrice } = useFormat();
  const region = useSelector((state) => state.region.region);
  const user = useSelector((state) => state.user_data.user_data ?? "");
  const [summary, setSummary] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [promocode, setpromocode] = useState(
    localStorage.getItem("promocode") ?? ""
  );
  const [promoApplied, setPromoApplied] = useState(false);
  const [promoAppliedValue, setPromoAppliedValue] = useState(0);

  const fetchCalculateTotals = async () => {
    setIsLoading(true);
    let data = "";
    if (promocode) {
      localStorage.setItem("promocode", promocode);

      let company_id = user?.company?.id;
      data = await calculatePromoCodes(
        selectedLines,
        region,
        company_id,
        promocode
      );
      setPromoApplied(true);
    } else {
      data = await calculateTotals(selectedLines, region);
    }

    if (data?.message) {
      toast.error(data?.message);
      setPromoApplied(false);
      setSummary({
        total_gross: 0,
        total_net: 0,
        total_promocode_discount: 0,
      });
      setpromocode("");
      setPromoAppliedValue(0);
    } else {
      setSummary(data?.summary);
      setPromoAppliedValue(data?.summary?.total_promocode_discount ?? 0);
    }
    setIsLoading(false);
  };

  const removePromoCode = async () => {
    setIsLoading(true);

    localStorage.removeItem("promocode");
    await calculateTotals(selectedLines, region);

    setpromocode("");
    setPromoApplied(false);
    setIsLoading(false);
    setPromoAppliedValue(0);
  };

  const toInputUppercase = (e) => {
    e.target.value = ("" + e.target.value).toUpperCase();
  };

  const calcTotal = () => {
    let total = summary?.total_net - promoAppliedValue;
    return formatPrice(total);
  };

    useEffect(() => {
        fetchCalculateTotals();

    }, [selectedLines, region, user?.company?.id]);

  return (
    <>
      <h6 className="text-2xl mb-32">Payment Summary</h6>

      {summary && (
        <div>
          <div className="border border-dark-gray rounded-8 p-24">
            <div className="mb-32 flex-between gap-8">
              <span className="text-gray-900 font-heading-two">Subtotal</span>
              <span className="text-gray-900 fw-semibold">
                {formatPrice(summary?.total_gross)}
              </span>
            </div>
            <div className="mb-32 flex-between gap-8">
              <span className="text-gray-900 font-heading-two">VAT</span>
              <span className="text-gray-900 fw-semibold">
                {formatPrice(summary?.total_net - summary?.total_gross)}
              </span>
            </div>
            <div className="mb-0 flex-between gap-8">
              <span className="text-gray-900 font-heading-two">
                Promotion applied
              </span>
              <span className="text-gray-900 fw-semibold">
                {formatPrice(promoAppliedValue)}
              </span>
            </div>
          </div>
          <div className="border border-dark-gray rounded-8 p-24 mt-24">
            <div className="flex-between gap-8">
              <span className="text-gray-900 text-2xl fw-semibold">Total</span>
              <span className="text-gray-900 text-xl fw-semibold">
                {calcTotal()}
              </span>
            </div>
          </div>
        </div>
      )}
      <div className="border border-dark-gray rounded-8 p-10 mt-24">
        <div className="p-10">
          <p className="text-black text-lg">
            Shipping are calculated at checkout.
          </p>
        </div>
        <div className="flex-align d-flex flex-column p-5">
          {promoApplied === true && (
            <div className="d-flex">
              <div className="fw-bold text-success">{promocode} Applied</div>

              <Link
                className="w-52 h-52 pl-25 pr-25 rounded-circle"
                onClick={removePromoCode}
              >
                {isLoading ? (
                  <i className="ph ph-spinner animate-spin text-2xl d-flex" /> // Spinning icon
                ) : (
                  <i className="ph ph-x-circle text-2xl d-flex" />
                )}
              </Link>
            </div>
          )}

          <div className="d-flex align-items-center">
            <input
              type="text"
              className="form-control w-80 mr-25"
              placeholder="Apply Promocode"
              value={promocode}
              onInput={toInputUppercase}
              onChange={(e) => setpromocode(e.target.value)}
            />
            <Link
              className="btn align-items-center px-5 py-10 bg-main-product-50 hover-bg-main-product-50"
              onClick={fetchCalculateTotals}
              disabled={isLoading}
            >
              Apply
            </Link>
          </div>
        </div>
        <div className="flex-align gap-8 d-flex flex-column p-10">
          {isLoading ? (
            <i className="ph ph-spinner animate-spin text-2xl d-flex" /> // Spinning icon
          ) : (
            <Link
              to="/checkout"
              className="btn align-items-center w-100 mt-2 bg-main-product-50 hover-bg-main-product-50"
              disabled={isLoading}
            >
              Continue to Checkout
            </Link>
          )}
        </div>
      </div>
    </>
  );
};

export default PaymentSummary;